import { Button } from '@progress/kendo-react-buttons';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { LoginIdentityProviderResultCode } from '../../../common/enums';
import { getRemoteAuthenticationUrl } from '../../../configs/env';
import { LoadingIndicatorLinear } from '../../components/indicators/LoadingIndicatorLinear';
import { useAuthProvider } from '../../contexts/AuthProvider';
import { useIsAuthenticated } from '../../hooks/use-is-authenticated';
import { useSafeEffect } from '../../hooks/use-safe-effect';
import { ROUTES } from '../../router/routes';

export function RemoteLoginCallback() {
    const [busy, setBusy] = useState(true);
    const [result, setResult] = useState<LoginIdentityProviderResultCode | null>(null);
    const context = useAuthProvider();
    const isAuthenticated = useIsAuthenticated(context);
    const navigate = useNavigate();

    useSafeEffect(() => {
        context.instance.completeSooLogin().then((result) => {
            setBusy(false);
            setResult(result);
            if (result === LoginIdentityProviderResultCode.ok) {
                navigate(ROUTES.HOME);
            }
        });
    }, []);

    const loginWithCommunityPortal = async () => {
        setBusy(true);
        if (isAuthenticated) {
            await context.instance.logout();
        }
        window.location.href = getRemoteAuthenticationUrl();
    };

    const handleLoginWithDifferentAccount = async () => {
        setBusy(true);
        if (isAuthenticated) {
            await context.instance.logout();
        }
        navigate(ROUTES.LOGIN, { replace: true });
    };

    return (
        <div>
            {busy ? (
                <LoadingIndicatorLinear />
            ) : (
                <div className="d-flex flex-column text-center gap-2">
                    <div className="text-danger">
                        {result !== null &&
                            result !== LoginIdentityProviderResultCode.ok &&
                            (ssoErrorMessages[result] || ssoErrorMessages[LoginIdentityProviderResultCode.serviceUnavailable])}
                    </div>
                    <Button style={{ textTransform: 'unset' }} themeColor={'primary'} onClick={loginWithCommunityPortal}>
                        Try different Community Portal account
                    </Button>
                    <Button style={{ textTransform: 'unset' }} onClick={handleLoginWithDifferentAccount}>
                        Login with Flight Explorer account
                    </Button>
                </div>
            )}
        </div>
    );
}

const ssoErrorMessages: Record<LoginIdentityProviderResultCode, string> = {
    [LoginIdentityProviderResultCode.noMatch]:
        'Your Community Portal account is not linked to any Flight Explorer account. Please contact Flight Explorer support.',
    [LoginIdentityProviderResultCode.noAccessProvider]:
        'Account not authorized for Flight Explorer access. Please contact Community Portal support.',
    [LoginIdentityProviderResultCode.noAccessFlightExplorer]: 'Account not authorized for web access',
    [LoginIdentityProviderResultCode.expired]: 'Account expired. Please contact Flight Explorer support.',
    [LoginIdentityProviderResultCode.disabled]: 'Account expired. Please contact Flight Explorer support.',
    [LoginIdentityProviderResultCode.tooManySessions]: 'Connection limit exceeded.',
    [LoginIdentityProviderResultCode.unknownError]: 'Unknown error has occurred. Please try again later.',
    [LoginIdentityProviderResultCode.serviceUnavailable]: 'Service unavailable. Please try again later.',
    [LoginIdentityProviderResultCode.ok]: ''
};
